import { allExperiments } from './allExperiments/index.js';
import { isServerSide } from '../../../helpers/env/isServerSide.js';
const forcedVariantForLocalHost = () => {
    if (window.location.href.indexOf('localhost') > -1) {
        const forcedVariant = new URLSearchParams(window.location.search).get('optimizely_x');
        return forcedVariant || null;
    }
};
export const getOptimizelyVariant = (experimentName) => {
    if (isServerSide() || !(experimentName in allExperiments))
        return;
    const currExperiment = allExperiments[experimentName];
    const { experimentId, variantsIds } = currExperiment;
    const activeExperiments = window.optimizelyEdgeStst?.activeExperiments || {};
    const forcedVariantForLocal = forcedVariantForLocalHost();
    if (activeExperiments[experimentId] || forcedVariantForLocal) {
        const activeVariantId = activeExperiments?.[experimentId]?.variation?.id || forcedVariantForLocal;
        const variantKey = Object.keys(variantsIds).find((key) => variantsIds[key] === activeVariantId);
        return variantKey;
    }
};
//# sourceMappingURL=optimizelyExperiments.js.map